import { GraphQLTaggedNode } from 'relay-runtime';
import { useReadFragmentInterop } from './useReadFragmentInterop';
import { FragmentRef } from './useFragmentizedQuery';

export const useFragmentizedFragment = <TFragmentData>(
	fragmentNode: GraphQLTaggedNode,
	fragmentRef: FragmentRef,
): TFragmentData => {
	const readFragmentInterop = useReadFragmentInterop<TFragmentData>({
		// This is needed because Relay generated artifacts for fragments do not have params.text yet: https://product-fabric.atlassian.net/browse/CCE2EPERF-622
		fragmentSpec: fragmentNode,
	});

	return readFragmentInterop({
		id: `${fragmentRef?.__typename}:${fragmentRef?.id}`,
	}) as TFragmentData;
};
